import { createGlobalStyle } from 'styled-components';
import { borderRadius, fontFamily } from '../common/hooks/useClientTheme';
import { color } from '@nuvolo/nuux-theme/utils';
import '../static/fonts/inter.css';
import { isDarkTheme } from '#/common/utils/themeDetection';

const GlobalStyles = createGlobalStyle`

  /* Invert dropdown icon when dark theme is active on nuvo-basic-dropdown*/
  ${({ theme }) => {
    if (isDarkTheme(theme)) {
      return `
        .nuvo-basic-dropdown .dx-button-content > i,
        .cards-dropdown-select .dx-button-content .dx-dropdowneditor-icon:before {
          filter: invert(1);
        }
      `;
    }
    return '';
  }}
  
  /* Target everything to apply fonts */
  html, body, #root, *, *::after,
  .MuiTypography-root, /* Target MUI specifically */
  [class*="nuux-"], /* Target Nuvolo components */
  .dx-widget /* Target DevExtreme */ {
    font-family: ${fontFamily};
  }

  .dx-scrollable-scroll-content {
    background-color: ${color('ui', 'light')} !important;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: ${color('ui', 'light')} ${color('custom', 'dataGridBackground')};
  }

  :root, body, #root {
    height: 100dvh;
    overflow: hidden; 
  }

  .dx-popup-wrapper{
    [aria-label="Column Chooser"].dx-overlay-content {
    background-color: ${color('custom', 'columnChooserBackground')} !important;
  }
  }

  p, ul, ol {
    margin: 0;
  }
  .bold{
    font-weight: 600;
  }
  a {
    color: ${color('custom', 'link')} !important;
  }
  .gray {
    color: ${color('primary', 'middle')};
  }
  .config-item-label {
    color: ${color('custom', 'constLightGray')} !important;
    margin-bottom: 4px;
  }
  .flex {
    display: flex;
  }
  .gap-12 {
    gap: 12px;
  }

  .dx-overlay-content.dx-popup-normal .dx-scrollview-content {
    background-color: ${color('custom', 'dataGridBackground')};
  }

  /* Default background for tables/data grids  */
  .dx-scrollable-wrapper,
  .dx-datagrid-header-panel,
  .dx-toolbar-items-container,
  .dx-widget.dx-datagrid-pager.dx-pager {
    background-color: ${color('custom', 'dataGridPageBackground')} !important;
  }

  /* Form-specific background override  */
  .tmm-page-form .dx-scrollable-wrapper,
  .tmm-page-form .dx-datagrid-header-panel,
  .tmm-page-form .dx-toolbar-items-container,
  .tmm-page-form .dx-widget.dx-datagrid-pager.dx-pager {
    background-color: ${color('custom', 'formBackground')} !important;
  }

  /* Dashboard-specific background  */
  .tmm-page-dashboard .dx-scrollable-wrapper,
  .tmm-page-dashboard .dx-datagrid-header-panel,
  .tmm-page-dashboard .dx-toolbar-items-container,
  .tmm-page-dashboard .dx-widget.dx-datagrid-pager.dx-pager {
    background-color: ${color('custom', 'formBackground')} !important;
  }

.dx-overlay-content.dx-popup-normal.dx-popup-draggable.dx-popup-flex-height.dx-resizable {
  border-radius: ${borderRadius?.m} !important;
  overflow: hidden !important;
  .dx-popup-title{
    h1{
      font-size: 20px;
      font-weight: 500;
    }
  }
}
// tooltip and popup overrides for data grid action items
.dx-overlay-wrapper.dx-popup-wrapper.dx-tooltip-wrapper {
  .dx-overlay-content {
    background-color: transparent !important;
    box-shadow: none !important;
    border: none !important;
    .dx-popup-content {
      background-color: transparent !important;
      box-shadow: none !important;
      border: none !important;
      padding: 0 !important;
      margin: 0 !important;
      > div {
        background-color: transparent !important;
        box-shadow: none !important;
        border: none !important;
        padding: 0 !important;
        margin: 0 !important;
        > div {
          background-color: ${color('custom', 'dataGridBackground')} !important;
          box-shadow: 0 4px 24px 0 ${color('custom', 'contrastText', 0.1)} !important;
          padding: 8px 12px !important;
          margin: 0 !important;
        }
      }
    }
  }
}

.dx-toast-wrapper .dx-toast-content {
  align-items: normal;

  width: auto;
  padding: 0;

  border-radius: var(--border-radius-base);

  box-shadow: var(--elevation-lvl3);
}

.dxm-tooltip {
  // map chart tooltip
  path {
    fill: transparent;
  }
}
.dxc-tooltip{
  z-index: 2000 !important;
  > div {
    > div {
      > div {
        background-color: ${color('custom', 'dataGridBackground')} !important;
      }
    }
  }
  h3 {
    color: ${color('custom', 'contrastText')} !important;
  }
}

h2{
  // Override h2 to not capitalize text
  text-transform: none !important;
}
.dx-checkbox-icon{
  border-radius: 6px;
}
  /* Card component styles */
  .nuvo-card-wrapper {
    & > div > div[display="flex"]:has(> div[width="4"]) {
     gap: 0 !important;
     padding: 0 !important;
     & div[width="4"]{
      display: none !important;
     }
     & div[width="100%"]{
      padding: 0 !important;
     }
    }
  }
  #selector-row:has(.asset),
  #selector-row:has(.contact-person),
  #selector-row:has(.contact-email),
  #selector-row:has(.parentId),
  #selector-row:has(.parent-location),
  #selector-row:has(.address),
  #selector-row:has(.created-by) {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
#selector-row {
  .card-value {
    width: 100%;
    text-overflow: ellipsis;
  }
}
  .card-wrapper {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;

    .divider {
      border-top: 1px solid ${color('primary', 'light2')} !important;
      border-bottom: 0px !important;
      border-left: none;
      border-right: none;
      margin: 8px 0;
    }

    .card-label {
      font-size: 14px;
      color: ${color('secondary', 'light')};
    }

    .card-value {
      font-size: 16px;
      color: ${color('secondary', 'dark3')};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-head {
      display: flex;
      justify-content: space-between;
      flex-direction: column-reverse;
      gap: 8px;
      .card-value{
        font-weight: 700;
      }
    }

    .card-head.with-icon {
      flex-direction: row;
      justify-content: normal;
      gap: 0;
      align-items: center;
    }

    .card-info-desktop {
      display: none;
    }

    .card-info-mobile {
      display: block;
      margin-top: 8px;
      .card-value{
        font-weight: 700;
      }
    }

    .card-body {
      display: flex;
      flex-wrap: wrap;
      row-gap: 8px;
      column-gap: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      div{
        width: 100%;
      }
      @media (min-width: 450px) {
      div {
        flex: 1 1 calc(25% - 18px);
      }
      div:nth-child(4) ~ div,
      div:nth-child(4) {
        max-width: calc(25% - 18px);
      }
    }
  }
}
  
  .dx-lookup-field{
    border-radius: 8px;
    border: 1px solid ${color('custom', 'borderLight')};
    height: 42px;
    padding: 12px 29px 8px 11px;
  }
  .dx-list-reorder-handle{
    color: ${color('custom', 'constLightGray')} !important;
    font-size: 24px !important;
    opacity: 1 !important;
  }
  .dx-toast-content{
    svg{
      display:none;
    }
  }

  /* Base toast styling for all types */
  .dx-overlay-content.dx-toast-content {
    &.dx-toast-warning {
      border: 1px solid ${color('warn', 'light')};
      div:nth-child(2) {
        background-color: ${color('warn', 'light3')};
        div {
          background-color: initial;
        }
      }
    }

    &.dx-toast-success {
      border: 1px solid ${color('success', 'light')};
      div:nth-child(2) {
        background-color: ${color('success', 'light3')};
        div {
          background-color: initial;
        }
      }
    }

    &.dx-toast-error {
      border: 1px solid ${color('error', 'light')};
      div:nth-child(2) {
        background-color: ${color('error', 'light3')};
        div {
          background-color: initial;
        }
      }
    }

    &.dx-toast-info {
      border: 1px solid ${color('info', 'light')};
      div:nth-child(2) {
        background-color: ${color('info', 'light3')};
        div {
          background-color: initial;
        }
      }
    }
  }
  .dx-overlay-content.dx-toast-content.dx-toast-warning{
    border: 1px solid ${color('warn', 'light')};;
    div:nth-child(2){
      background-color: ${color('warn', 'light3')};
      div{
        background-color:initial;
      }
    }
  }
  .dx-overlay-content.dx-toast-content.dx-toast-success{
    border: 1px solid ${color('success', 'light')};;
    div:nth-child(2){
      background-color: ${color('success', 'light3')};
      div{
        background-color:initial;
      }
    }
  }
  .dx-overlay-content.dx-toast-content.dx-toast-error{
    border: 1px solid ${color('error', 'light')};;
    div:nth-child(2){
      background-color: ${color('error', 'light3')};
      div{
        background-color:initial;
      }
    }
  }
  .dx-overlay-content.dx-toast-content.dx-toast-info{
    border: 1px solid ${color('info', 'light')};;
    div:nth-child(2){
      background-color: ${color('info', 'light3')};
      div{
        background-color:initial;
      }
    }
  }
  .nuvo-toast-action-button{
    border-radius: ${borderRadius?.s || '16px'} !important;
    height: 44px !important;
    background-color:  transparent !important;
    &.dx-state-focused{
      border-color: transparent !important;
    }
    .dx-state-hover{
      border: none !important;
    }
    &.dx-state-hover{
      background-color: ${color('ui', 'light2')} !important;
      box-shadow: none !important;
    }
    .dx-button-content{
      color: ${color('primary', 'dark')} !important;
      font-size:16px !important;
    }
    &:last-child{
    &.dx-state-hover{
      box-shadow: none !important;
      background-color: ${color('primary', 'dark')} !important;
    }
    background-color:  ${color('primary', 'dark')} !important;
    .dx-button-content{
      color: ${color('primary', 'light')} !important;
    }
    }
  }
  .custom-toast-message{
    font-size: 16px !important;
  }

  .cards-dropdown-select .dx-button-content .dx-dropdowneditor-icon:before {
    position:relative;
    top: -2px;
    font-size: 0 !important;
    display: inline-block;
    background: url('/assets/angle-down-solid-full.svg') no-repeat;
    color: transparent !important;
  }
  .nuvo-basic-dropdown{
    border-color: ${color('primary', 'light')} !important;
    &.dx-state-focused{
      border: 1px solid black !important;
      box-shadow: none !important;

    }
    &.dx-dropdowneditor-active{
      border: 1px solid black !important;
      box-shadow: none !important;
    }
    margin-top: 5px;
    border-radius: ${borderRadius?.s} !important;
    .dx-button-content > i {
      position:relative;
      left: -7px;
      font-size: 0 !important;
      width: 13px;
      height: 13px;
      display: inline-block;
      background: url('/assets/angle-down-solid-full.svg') no-repeat;
      color: transparent !important;
    }
  }
  .dx-toolbar.dx-widget.dx-visibility-change-handler.dx-collection.dx-popup-title.dx-has-close-button{
    .dx-toolbar-items-container{
      background-color: ${color('custom', 'columnChooserBackground')} !important;
    }
  }
  .nuvo-modal-base{
    .dx-scrollable-wrapper{
      background-color: ${color('custom', 'dataGridBackground')} !important;
    }
  }
  .dx-popup-content{
    .dx-treeview-node-container{
      background-color:  ${color('custom', 'columnChooserBackground')};
      .dx-item{
        background-color: ${color('custom', 'columnChooserItemBackground')} !important;
      }
    }
  }
  .dx-datagrid-column-chooser .dx-overlay-content{
    background-color:  ${color('custom', 'columnChooserBackground')} !important;
  }
  
  /* Move calendar icon little bit */
  .dx-widget.dx-button-mode-contained.dx-button-normal.dx-dropdowneditor-button {
    margin-right: 8px !important;
  }
  .dx-item.dx-list-item.dx-state-hover{
    background-color: transparent !important;
  }
  .form-dropdown-popup:not(.cards-dropdown-popup) .dx-item.dx-list-item.dx-list-item-selected.dx-state-hover,
  .form-dropdown-popup:not(.cards-dropdown-popup) .dx-item.dx-list-item.dx-state-hover {
    background-color:  ${color('ui', 'light3')} !important;
  }
  .custom-toast-message{
    color: ${color('custom', 'contrastText')} !important;
  }
  .dx-context-menu .dx-submenu{
    background-color: ${color('custom', 'columnChooserBackground')}  !important;
  }
  .dx-context-menu {
    background-color: transparent !important;
  }
  body > div.dx-overlay-wrapper.dx-popup-wrapper.nuvo-modal-base.dx-overlay-shader > div > div.dx-popup-title {
    border-bottom: none !important;
  }
  .dx-loadindicator-segment-inner{
    border-color: ${color('custom', 'selectedBackground')} ${color('custom', 'selectedBackground')} transparent !important;
  }
  .dx-popup-wrapper > .dx-overlay-content {
    background-color: ${color('custom', 'dataGridBackground')} !important;
  }
  .dx-calendar{ 
    background-color: ${color('custom', 'dataGridBackground')} !important;
  }
  .dx-clear-button-area{
    position: relative;
    left: -3px;
  }
  .dx-toolbar.dx-widget.dx-visibility-change-handler.dx-collection.dx-popup-bottom{
    .dx-toolbar-items-container{
      background-color: ${color('custom', 'dataGridBackground')} !important;
    }
  }
  .dxc-hole-template{
    svg{
      circle{
        fill: ${color('custom', 'cardBackground')} !important;
      }
    }
  }
  .dxc-legend{
    text{
      fill: ${color('custom', 'contrastText')} !important;
    }
  }
  text[text-anchor="middle"] {
  fill: ${color('custom', 'contrastText')} !important;
}
.dx-dropdownlist-popup-wrapper .dx-list-item {
  background-color: ${color('custom', 'invertedText')}  !important;
}
.nuvo-basic-dropdown.dx-texteditor.dx-editor-outlined{
  background-color:  ${color('custom', 'invertedText')};
  border-color: ${color('custom', 'formInputBorder')} !important;
}
.dx-list .dx-empty-message{
  font-size: 24px !important;
  height: 520px;
  border-radius: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${color('custom', 'formImageWrapperBackground')} !important;
  color: ${color('primary', 'dark')} !important;
  font-weight: 600;
  padding: 0;
  text-transform: capitalize;
}

.dx-button.dx-button-default {
  background-color: ${color('custom', 'invertedBackground')} !important;
}

.dx-overlay-wrapper.dx-popup-wrapper.nuvo-modal-base.dx-overlay-shader {
  background-color: ${color('custom', 'invertedBackground', 0.75)};
}
.dx-fileuploader-file-container{
  background-color: transparent !important;
  .dx-fileuploader-file-name{
    color: ${color('custom', 'contrastText')} !important;
  }
  .dx-fileuploader-file-status-message{
    color: ${color('custom', 'contrastText')} !important;
  }
}
.dx-popup-wrapper > .dx-overlay-content {
  // Overlay box shadow styles --- very important
  box-shadow: 0 4px 24px 0 ${color('custom', 'contrastText', 0.1)} !important;
  border: 1px solid ${color('secondary', 'light3')} !important;
}
.dx-checkbox-checked .dx-checkbox-icon{
  color: ${color('custom', 'invertedBackground')} !important;
}
.dx-checkbox-indeterminate .dx-checkbox-icon {
  color: ${color('custom', 'invertedBackground')} !important;
}
.dx-calendar-selected-date{
  span{
    color: ${color('custom', 'invertedBackground')} !important;
  }
}
.dx-show-clear-button .dx-icon-clear{
  background-color: transparent !important;
  color: ${color('custom', 'contrastText')} !important;
  scale: 1.2;
  &:before {
    color: transparent !important;
  }
}

  /* Remove the default bottom border of the modal title */
  body > div.dx-overlay-wrapper.dx-popup-wrapper.nuvo-modal-base.dx-overlay-shader > div > div.dx-popup-title {
    border-bottom: none !important;
  }

  // added bottom padding to scrollable wrapper in organizations modal - based on tenant-item class
  .dx-overlay-wrapper.dx-popup-wrapper.nuvo-modal-base .dx-popup-content:has(.tenant-item) .dx-scrollable-wrapper {
    padding-bottom: 16px !important;
    &::after {
    // slight fade effect at the bottom of the scrollable area
    content: '';
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 64px;
    filter: blur(3px);
    ${({ theme }) => {
      if (isDarkTheme(theme)) {
        return `background: linear-gradient(180deg, rgb(21, 23, 25, .5) 44.33%,rgb(21, 23, 25) 65%);`;
      }
      return `background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 1) 100%);`;
    }}
    pointer-events: none;
    z-index: 999;
    @media (max-width: 1024px) {
      display: none;
    }
  }
    .dx-scrollview-content {
      padding-top: 0 !important;
    }
  }
  .dx-popup-content div[type="primary"] {
    background-color: transparent !important;
  }
  .dx-overlay-wrapper.dx-popup-wrapper .dx-overlay-content:has(.dx-calendar) .dx-toolbar-items-container {
    background-color: ${color('custom', 'dataGridBackground')}  !important;
    border-bottom: 1px solid ${color('primary', 'light3')} !important;
  }


  .mobile-list-multiselect-dropdown {
    background-color: ${color('custom', 'cardBackground')}!important;
    border-color: ${color('custom', 'formInputBorder')}!important;
    color: ${color('custom', 'contrastText')}!important;

    .dx-tag-content {
      background: ${color('secondary', 'light3')}!important;
    }
  }   

  .nuvo-toolbar-button-danger {
    .dx-button-content i {
      color: ${color('accent', 'dark3')} !important;
    }
  }

  #atlwdg-container {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    margin: 0 !important;
  }
  #atlwdg-iframe {
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
  }

  /* SelectCard Styles */
  .select-card-container {
    padding: 16px 0;
  }
  .width-50{
    width: 50% !important;
  }
  .width-100{
    width: 100% !important;
  }

  .dx-popup-title h1 {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  /* Cards dropdown SelectBox input styling - ensures chevron is inside the input */
  .cards-dropdown-select.dx-selectbox {
    .dx-dropdowneditor-button {
      width: 32px;
      min-width: 32px;
      margin-right: 0 !important;
    }
    
    .dx-texteditor-buttons-container {
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  /* Cards dropdown popup styles for RelatedItemsCards */
  .cards-dropdown-popup {
    .dx-overlay-content {
      background-color: ${color('custom', 'fancyDropDownBackground')} !important;
      border-radius: 24px !important;
    }

    .dx-popup-content {
      padding: 8px !important;
      background-color: ${color('custom', 'fancyDropDownBackground')} !important;
    }

    .dx-scrollable-wrapper,
    .dx-scrollable-container {
      background-color: ${color('custom', 'fancyDropDownBackground')} !important;
    }

    .dx-scrollview-content,
    .dx-list {
      background-color: ${color('custom', 'fancyDropDownBackground')} !important;
    }
    
    .dx-list-item {
      padding: 4px !important;
      border: none !important;
      background: transparent !important;
      
      &.dx-state-hover {
        background: transparent !important;
      }
      
      &.dx-state-focused {
        background: transparent !important;
      }

      &.dx-list-item-selected {
        background: transparent !important;
      }

      &.dx-list-item-selected.dx-state-hover {
        background: transparent !important;
      }
      
      .dx-list-item-content {
        padding: 0 !important;
      }
    }
    
    .dx-scrollview-content {
      display: grid !important;
      row-gap: 6px;
      padding: 0px !important;
    }
  }
  
  /* Two columns layout (default for desktop) */
  .cards-dropdown-popup.cards-two-columns {
    .dx-overlay-content {
      min-width: 500px !important;
    }
    
    .dx-scrollview-content {
      grid-template-columns: repeat(2, 1fr) !important;
      
      /* Hide ::before and ::after pseudo-elements in two-column view */
      &::before,
      &::after {
        display: none !important;
      }
    }
    
    @media (max-width: 768px) {
      .dx-overlay-content {
        min-width: unset !important;
      }
      
      .dx-scrollview-content {
        grid-template-columns: 1fr !important;
      }
    }
  }
  
  .cards-dropdown-popup.cards-single-column {
    .dx-scrollview-content {
      grid-template-columns: 1fr !important;
    }
  }
  .cards-dropdown-popup .dx-list-item.dx-list-item-selected .select-card {
    background-color: ${color('custom', 'focusItemBackground')} !important;
    
    .checkmark-wrapper {
      opacity: 1 !important;
    }
  }

  .dx-overlay-wrapper.dx-datagrid-filter-range-overlay {
    .dx-overlay-content {
      background-color: ${color('custom', 'dataGridBackground')};
      .dx-placeholder {
        color: ${color('custom', 'contrastText')};
      }
      .dx-numberbox {
        display: block !important;
      }
    }
  }

  .dx-overlay-wrapper.dx-datagrid-filter-range-overlay .dx-overlay-content .dx-placeholder {
    color: ${color('custom', 'contrastText')};
  }

  .coming-soon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 520px;
    border-radius: 32px;
    background-color: ${color('custom', 'formImageWrapperBackground')};
    font-size: 24px;
    font-weight: 600;
    text-transform: capitalize;
  }
`;

export default GlobalStyles;
